module.exports = __webpack_public_path__ + "img/logo_aigrow.203eaca3.png";